import EnbProdutos from '@/components/Theme03/Produtos/EnbProdutos'
import ProdutoView from '@/components/Theme03/Produtos/ProdutoView/ProdutoView'
import SearchResult from '@/components/Theme03/Search/SearchResult'
import EnbProfile from '@/components/Profile/EnbProfile'
import EnbLikes from '@/components/Theme01/Like/EnbLikes'

export default [
  {
    path: '/login',
    name: 'Login',
    component: EnbProdutos,
    meta: { login: true }
  },
  {
    path: '/site',
    name: 'Loja',
    component: EnbProdutos
  },
  {
    path: '/site/:categ',
    name: 'Loja Categ',
    component: EnbProdutos
  },
  {
    path: '/',
    name: 'Produtos03',
    component: EnbProdutos
  },
  {
    path: '/categorias',
    name: 'Categorias',
    component: EnbProdutos
  },
  {
    path: '/:link',
    name: 'Produto',
    component: ProdutoView
  },
  {
    path: '/site/:categ/:link',
    name: 'Categoria Produto',
    component: ProdutoView
  },
  {
    path: '/search',
    name: 'Pesquisa',
    component: SearchResult
  },
  {
    path: '/profile',
    name: 'Profile',
    component: EnbProfile
  },
  {
    path: '/likes',
    name: 'Likes',
    component: EnbLikes
  }
]
